import React, { useEffect, useState } from "react"

interface iForm {
  data: any
  onSubmit: (data: any) => void
  children: (data: any, setData: (key: string, value: any) => void) => any
  onChange?: (data: {
    data: any
    recentUpdate: { key: string; value: any }
  }) => void
}

const Form: React.FC<iForm> = ({ data, onSubmit, children, onChange }) => {
  const [dataState, setDataState] = useState<{
    data: any
    recentUpdate: { key: string; value: any } | null
  }>({
    data: data,
    recentUpdate: null,
  })

  // If the data prop gets updated.
  useEffect(
    () =>
      setDataState({
        data: data,
        recentUpdate: null,
      }),
    [data]
  )

  const setData = (key: string, value: any) => {
    setDataState({
      data: { ...dataState.data, [key]: value },
      recentUpdate: { key, value },
    })
  }

  useEffect(() => {
    if (onChange && dataState.recentUpdate !== null) {
      // @ts-ignore
      onChange(dataState)
    }
  }, [dataState])

  const onFormSubmit = (e: any) => {
    onSubmit(dataState.data)
    e.preventDefault()
  }

  return (
    <form className="p-0 m-0" onSubmit={onFormSubmit}>
      {children(dataState.data, setData)}
    </form>
  )
}

export default Form
